export default __webpack_public_path__ + "static/webRotator/svg/37512f71873c5f0b3e6619864cd531a0.svg";